/**
 * We are bootstrapping the js here this is similar to how laravel does it.
 * You can import any jquery plugins here.
 */
window.$ = window.jQuery = require('jquery');

/**
 * Require all jquery plugins here they need to be added to window otherwise,
 * they will not be able to be used and you will get the error function not found
 */
window.superfish = require('superfish');
window.slick = require('slick-carousel');